module.exports = __webpack_public_path__ + "static/media/2.bcba93b1.jpg";